exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".announcementCustomModal .ant-modal-header {\n  border: none;\n  display: inline-block;\n  position: absolute;\n  z-index: 1;\n  right: 56px;\n  padding: 0;\n}\n.announcementCustomModal .ant-modal-header .ant-modal-title .custom-btn {\n  width: 56px;\n  height: 56px;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.announcementCustomModal .daily-article {\n  border-bottom: 0;\n}\n", ""]);

// exports
